export default function RouletteIcon({}) {
  return (
    <>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M12.6123 2C13.3757 2 13.9701 2.55786 14.0898 3.24414C18.0526 4.18645 21 7.74891 21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.89459 5.74929 4.43283 9.50684 3.35156C9.58042 2.62162 10.1914 2 11 2H12.6123ZM6.70898 17.9971C8.00265 19.1393 9.66702 19.8694 11.5 19.9824V13.2051L6.70898 17.9971ZM12.5 19.9824C14.3327 19.8694 15.9965 19.139 17.29 17.9971L12.5 13.207V19.9824ZM4.01758 12.5C4.13061 14.3325 4.86024 15.9965 6.00195 17.29L10.791 12.5H4.01758ZM17.9971 17.29C19.139 15.9964 19.8694 14.3327 19.9824 12.5H13.207L17.9971 17.29ZM6 6.70703C4.85795 8.00065 4.13063 9.66719 4.01758 11.5H10.793L6 6.70703ZM13.2051 11.5H19.9834C19.8703 9.66697 19.1403 8.0017 17.998 6.70801L13.2051 11.5ZM12.8965 7.3916C12.6223 8.21342 11.5301 8.30401 11.1016 7.60938L11.0244 7.45996L9.7207 4.33105C8.59222 4.66594 7.56688 5.24089 6.70703 6L11.999 11.292L17.29 6.00195C16.3465 5.16913 15.2062 4.55523 13.9463 4.24023L12.8965 7.3916ZM11 3C10.6432 3 10.4009 3.36306 10.5381 3.69238L11.9482 7.0752L13.0869 3.6582L13.1035 3.59766C13.1649 3.29408 12.9323 3 12.6123 3H11Z"
          fill="white"
        />
      </svg>
    </>
  );
}
